import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  constructor(private readonly api: ApiService) {}

  public async getPcAccountURL(): Promise<any> {
    return this.api.get<any>(environment.api.applicationConfiguration + '/pc/url');
  }
}
